// import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useTranslation } from 'react-i18next';

import { toggleBtnModalShortcuts } from '../../../redux/diagram/diagram.actions';
import { selectIsBtnModalShortcutsEnabled } from '../../../redux/diagram/diagram.selectors';

import { useShortKeysNavigation } from '../../../hooks/useShortKeysNavigation';

import Modal from '../Modal/Modal';
import './ModalKeyboardShortcuts.scss';


export const ModalKeyboardShortcuts = () => {
    const dispatch = useDispatch();

    const { t, i18n } = useTranslation();

    const { map: shortKeysMap } = useShortKeysNavigation();
    const isOpen = useSelector(selectIsBtnModalShortcutsEnabled);

    const handleCancel = () => {
        dispatch(toggleBtnModalShortcuts(null));
    };

    return (
        <Modal
            isModalSmall={true}
            isOpen={isOpen}
            modalClass={`modal-keyboard-shortcuts`}
            onCancel={handleCancel}
        >
            <div className="modal-content-header">{t('m_keyboard_shortcuts.title')}</div>
            <div className="modal-content-body">

                <div className="shortcuts_section_wrap">

                    {/* General */}
                    <div className='shortcuts_section first'>
                        <div className='shortcuts_title'>
                            <div className='shortcuts_title_text'>
                                <span>{t('m_keyboard_shortcuts.general.title1')}&nbsp;</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.general.items.search')}</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL}</span>
                                <span className='key-one-letter'>K</span>
                            </div>
                        </div>

                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.general.items.new_diagram')}</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL}</span>
                                <span className='text_shift'>{shortKeysMap?.SHIFT}</span>
                                <span className='key-one-letter'>O</span>
                            </div>
                        </div>
                        {/* <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.general.items.new_chat')}</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL}</span>
                                <span className='text_shift'>{shortKeysMap?.SHIFT}</span>
                                <span className='key-one-letter'>I</span>
                            </div>
                        </div> */}
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.general.items.settings')}</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL}</span>
                                <span className='key-one-letter'>,</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.general.items.toggle_sidebar')}</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL}</span>
                                <span className='key-one-letter'>B</span>
                            </div>
                        </div>

                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.general.items.keyboard_shortcuts')}</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL}</span>
                                <span className='key-one-letter'>/</span>
                            </div>
                        </div>
                        {/* <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.general.items.toggle_theme')}</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL}</span>
                                <span className='key-one-letter'>M</span>
                            </div>
                        </div> */}
                    </div>

                    {/* Controls Left */}
                    <div className='shortcuts_section'>
                        <div className='shortcuts_title'>
                            <div className='shortcuts_title_text'>
                                <span>{t('m_keyboard_shortcuts.ctrl_left.title1')}&nbsp;</span>
                                <span>{t('m_keyboard_shortcuts.ctrl_left.title2')}</span>
                            </div>
                        </div>
                        {/* <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctrl_left.items.mouse_sel')}</div>
                            <div className='shortcuts_item_key'>
                                <span className='key-one-letter'>V</span>
                            </div>
                        </div> */}
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctrl_left.items.table')}</div>
                            <div className='shortcuts_item_key'>
                                <span className='key-one-letter'>T</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctrl_left.items.line')}</div>
                            <div className='shortcuts_item_key'>
                                <span className='key-one-letter'>L</span>
                            </div>
                        </div>
                        {/* <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>New line: reference</div>
                            <div className='shortcuts_item_key'>
                                <span className='key-one-letter'>L</span>
                                <span className='key-then'>then</span>
                                <span className='key-one-letter'>R</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>New line: dependency</div>
                            <div className='shortcuts_item_key'>
                                <span className='key-one-letter'>L</span>
                                <span className='key-then'>then</span>
                                <span className='key-one-letter'>D</span>
                            </div>
                        </div> */}
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctrl_left.items.area')}</div>
                            <div className='shortcuts_item_key'>
                                <span className='key-one-letter'>A</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctrl_left.items.note')}</div>
                            <div className='shortcuts_item_key'>
                                <span className='key-one-letter'>N</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctrl_left.items.comment')}</div>
                            <div className='shortcuts_item_key'>
                                <span className='key-one-letter'>C</span>
                            </div>
                        </div>
                        {/* <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctrl_left.items.pen')}</div>
                            <div className='shortcuts_item_key'>
                                <span className='key-one-letter'>P</span>
                            </div>
                        </div> */}
                        {/* <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctrl_left.items.undo')}</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL}</span>
                                <span className='key-one-letter'>Z</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctrl_left.items.redo')}</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL}</span>
                                <span className='text_shift'>{shortKeysMap?.SHIFT}</span>
                                <span className='key-one-letter'>Z</span>
                            </div>
                        </div> */}
                    </div>


                    {/* Controls Top Left */}
                    <div className='shortcuts_section'>
                        <div className='shortcuts_title'>
                            <div className='shortcuts_title_text'>
                                <span>{t('m_keyboard_shortcuts.ctrl_top_left.title1')}&nbsp;</span>
                                <span>{t('m_keyboard_shortcuts.ctrl_top_left.title2')}</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctrl_top_left.items.export_img')}</div>
                            <div className='shortcuts_item_key'>
                                {/* <span>{shortKeysMap?.CTRL}</span> */}
                                <span className='key-one-letter'>E</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctrl_top_left.items.search')}</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL}</span>
                                <span className='key-one-letter'>K</span>
                            </div>
                        </div>
                        {/* <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctrl_top_left.items.editor_panel')}</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL}</span>
                                <span className='key-one-letter'>B</span>
                            </div>
                        </div> */}
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctrl_top_left.items.zoom_to_fit')}</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL}</span>
                                <span>Enter</span>
                            </div>
                        </div>
                    </div>


                    {/* Controls Bottom Right */}
                    <div className='shortcuts_section'>
                        <div className='shortcuts_title'>
                            <div className='shortcuts_title_text'>
                                <span>{t('m_keyboard_shortcuts.ctrl_bottom_right.title1')}&nbsp;</span>
                                <span>{t('m_keyboard_shortcuts.ctrl_bottom_right.title2')}</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctrl_bottom_right.items.minimap')}</div>
                            <div className='shortcuts_item_key'>
                                <span className='key-one-letter'>M</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctrl_bottom_right.items.full_screen')}</div>
                            <div className='shortcuts_item_key'>
                                <span className='key-one-letter'>F</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctrl_bottom_right.items.zoom_in')}</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL}</span>
                                <span className='key-one-letter'>+</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctrl_bottom_right.items.zoom_out')}</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL}</span>
                                <span className='key-one-letter'>-</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctrl_bottom_right.items.zoom_100')}</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL}</span>
                                <span className='key-one-letter'>0</span>
                            </div>
                        </div>
                    </div>



                    {/* Context Menu Table */}
                    <div className='shortcuts_section'>
                        <div className='shortcuts_title'>
                            <div className='shortcuts_title_text long'>
                                <span>{t('m_keyboard_shortcuts.ctx_tab.title1')}&nbsp;</span>
                                <span>{t('m_keyboard_shortcuts.ctx_tab.title2')}</span>
                            </div>
                            {/* <img className="shortcuts_title_img" src="/context_menu_table.png" /> */}
                        </div>
                        {/* <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Add description</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} + D</span>
                            </div>
                        </div> */}
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctx_tab.items.dupl_tab')}</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL}</span>
                                <span className='key-one-letter'>C</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctx_tab.items.del_tab')}</div>
                            <div className='shortcuts_item_key'>
                                <span>Del</span>
                            </div>
                        </div>
                    </div>

                    {/* Context Menu Table Column */}
                    <div className='shortcuts_section'>
                        <div className='shortcuts_title'>
                            {/* <div className='shortcuts_title_text long long-d'> */}
                            <div className='shortcuts_title_text'>
                                <span>{t('m_keyboard_shortcuts.ctx_tab_col.title1')}&nbsp;</span>
                                <span>{t('m_keyboard_shortcuts.ctx_tab_col.title2')}</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctx_tab_col.items.add_col_below')}</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL}</span>
                                <span>Enter</span>
                            </div>
                        </div>

                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctx_tab_col.items.focus_col_above')}</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL}</span>
                                <span>Up</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctx_tab_col.items.focus_col_below')}</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL}</span>
                                <span>Down</span>
                            </div>
                        </div>

                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctx_tab_col.items.move_col_up')}</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL}</span>
                                <span className='text_shift'>{shortKeysMap?.SHIFT}</span>
                                <span>Up</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctx_tab_col.items.move_col_down')}</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL}</span>
                                <span className='text_shift'>{shortKeysMap?.SHIFT}</span>
                                <span>Down</span>
                            </div>
                        </div>
                        {/* <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Add description</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} + D</span>
                            </div>
                        </div> */}
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctx_tab_col.items.dupl_col')}</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL}</span>
                                <span className='key-one-letter'>C</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctx_tab_col.items.del_col')}</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL}</span>
                                <span>Del</span>
                            </div>
                        </div>
                    </div>

                    {/* Context Menu Line */}
                    <div className='shortcuts_section'>
                        <div className='shortcuts_title'>
                            <div className='shortcuts_title_text long '>
                                <span>{t('m_keyboard_shortcuts.ctx_line.title1')}&nbsp;</span>
                                <span>{t('m_keyboard_shortcuts.ctx_line.title2')}</span>
                            </div>
                        </div>
                        {/* <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Add description</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} + D</span>
                            </div>
                        </div> */}
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctx_line.items.del_line')}</div>
                            <div className='shortcuts_item_key'>
                                <span>Del</span>
                            </div>
                        </div>
                    </div>

                    {/* Context Menu Area */}
                    <div className='shortcuts_section'>
                        <div className='shortcuts_title'>
                            <div className='shortcuts_title_text long'>
                                <span>{t('m_keyboard_shortcuts.ctx_area.title1')}&nbsp;</span>
                                <span>{t('m_keyboard_shortcuts.ctx_area.title2')}</span>
                            </div>
                        </div>
                        {/* <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Add description</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} + D</span>
                            </div>
                        </div> */}
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctx_area.items.dupl_area')}</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL}</span>
                                <span className='key-one-letter'>C</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctx_area.items.del_area')}</div>
                            <div className='shortcuts_item_key'>
                                {/* <span>{shortKeysMap?.CTRL} + Del</span> */}
                                <span>Del</span>
                            </div>
                        </div>
                    </div>

                    {/* Context Menu Multiselect Elements */}
                    <div className='shortcuts_section'>
                        <div className='shortcuts_title'>
                            <div className='shortcuts_title_text long'>
                                <span>{t('m_keyboard_shortcuts.ctx_multi.title1')}&nbsp;</span>
                                <span>{t('m_keyboard_shortcuts.ctx_multi.title2')}</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctx_multi.items.select_all')}</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL}</span>
                                <span className='key-one-letter'>A</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctx_multi.items.create_area_for_select_els')}</div>
                            <div className='shortcuts_item_key'>
                                <span className='key-one-letter'>A</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctx_multi.items.dupl_select_els')}</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL}</span>
                                <span className='key-one-letter'>C</span>
                            </div>
                        </div>
                        <div className='shortcuts_item no-bord'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctx_multi.items.del_select_els')}</div>
                            <div className='shortcuts_item_key'>
                                {/* <span>{shortKeysMap?.CTRL} + Del</span> */}
                                <span>Del</span>
                            </div>
                        </div>
                    </div>

                    {/* Context Menu Delete Table */}
                    <div className='shortcuts_section'>
                        <div className='shortcuts_title'>
                            <div className='shortcuts_title_text'>
                                <span>{t('m_keyboard_shortcuts.ctx_del_tab.title1')}&nbsp;</span>
                                <span>{t('m_keyboard_shortcuts.ctx_del_tab.title2')}</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctx_del_tab.items.yes')}</div>
                            <div className='shortcuts_item_key'>
                                <span>Enter</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctx_del_tab.items.no')}</div>
                            <div className='shortcuts_item_key'>
                                <span>Esc</span>
                            </div>
                        </div>
                    </div>

                </div>


                {/* <div className='button_wrap'>
                    <button
                        // disabled={!value}
                        onClick={() => handleCancel()}
                    >{t('b.close')}</button>
                </div> */}
            </div>
        </Modal>
    );
};

export default ModalKeyboardShortcuts;
